import { Plus } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../../../app-routes';
import { Button } from '../../../components/ui/button';

export const CreateSegmentButton: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Button onClick={() => navigate(appRoutes.ENGAGE_SEGMENTS_NEW)}>
      <Plus />
      New Segment
    </Button>
  );
};
